import React, { Component } from 'react';
import {
  withStyles, Typography, Toolbar,
  Fab,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { withRouter, Route, Switch } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {
  PersonAdd, AccountBalance,
  LockOutlined,
} from '@material-ui/icons';
import Icon from '@material-ui/core/Icon';
import Hidden from '@material-ui/core/Hidden';
import { connect } from 'react-redux';
import { ReactComponent as Logo } from '../../components/header/logo.svg';
import Register from './not-registered/register';
import NotRegistered from './not-registered';
import { doFetch } from '../../services/fetch/fetch.actions';
// eslint-disable-next-line object-curly-newline, no-unused-vars
import { fetchProfile, fetchRole } from '../../services/politician/profile-service';
import PendingPolitician from './pending/pending-politician';
import DisabledPolitician from './disabled/disabled-politician';
import EnabledPolitician from './enabled/enabled-politician';
import * as userConstants from '../admin/users/functions/constants';

const menuItems = [
  {
    icon: AccountBalance,
    text: 'Politikerbasen',
    path: '/',
    showFor: ['pending', 'disabled', 'enabled', undefined],
  },
  {
    icon: PersonAdd,
    text: 'Registrer deg',
    path: '/registrer',
    showFor: [undefined],
  },
];


class Politician extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutopen: false,
    };
  }

  componentDidMount() {
    const {
      profile: { fetched, fetching },
      dispatch,
      me: { fetched: adminFetched, fetching: adminFetching },
    } = this.props;
    if (!fetched && !fetching) {
      dispatch(doFetch('PROFILE', fetchProfile().then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })));
    }
    if (!adminFetched && !adminFetching) {
      dispatch(doFetch('ME', fetchRole().then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })));
    }
  }


  render() {
    const {
      classes, history, history: { location: { pathname } },
      profile: { payload: profile, fetched, error },
      me: { payload: me, fetched: meFetched, error: meError },
      users: { fetched: usersFetched, error: usersError },
    } = this.props;
    const { logoutopen } = this.state;

    const landingPages = {
      1: EnabledPolitician,
      0: DisabledPolitician,
      2: PendingPolitician,
    };

    return (
      <div className={classes.root}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <Toolbar className={classes.toolbar} onClick={() => history.push('/')}>
            <Icon className={classes.logo} color="inherit" aria-label="Menu">
              <Logo />
            </Icon>
            <Hidden smDown>
              <div className={classes.grow}>
                <Typography variant="subtitle1" color="inherit">
                  Trondheim kommune
                </Typography>
                <Typography color="inherit" variant="subtitle2">
                  Politikerbasen
                </Typography>
              </div>
            </Hidden>
          </Toolbar>
          <Divider />
          <List>
            {meFetched && (me.roles && (me.roles.includes('admin') || me.roles.includes('superadmin'))) && me.active === userConstants.ENABLED
              ? !(usersFetched && usersError === 'Forbidden') && history.push('/admin')
              : menuItems
                .filter(item => meFetched && item.showFor.includes(me.active))
                .map(({ icon: MenuEntryIcon, text, path }) => {
                  const selected = (path === '/' ? path === pathname : pathname.includes(path));
                  return (
                    <ListItem
                      selected={selected}
                      key={path}
                      onClick={() => history.push(path)}
                      button
                    >
                      <ListItemIcon className={classes.navItemIcon}><MenuEntryIcon color={selected ? 'primary' : 'inherit'} /></ListItemIcon>
                      <Hidden smDown><ListItemText primary={text} primaryTypographyProps={{ color: selected ? 'primary' : 'inherit' }} /></Hidden>
                    </ListItem>
                  );
                })}
          </List>
          <div className={classes.bottom}>
            <Hidden smDown>
              <Divider />
              <div className={classes.buttonbox}>
                <div className={classes.flex}>
                  <Typography variant="body1" color="primary" gutterBottom>
                    {fetched && !error && profile.navn}
                  </Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Logget inn
                  </Typography>
                </div>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  className={classes.login}
                  onClick={() => { window.location = `/idp-auth/self-log-me-out?post_logout_redirect_uri=${window.location.origin.replace('admin', '')}/`; }}
                >
                  <LockOutlined className={classes.personicon} color="primary" />
                  Logg ut
                </Button>
              </div>
            </Hidden>
          </div>
          <Hidden mdUp>
            <Fab size="small" className={classes.loginIcon} color="primary" onClick={() => this.setState({ logoutopen: true })}>
              <LockOutlined />
            </Fab>
          </Hidden>
          <Dialog key="dialog" open={logoutopen}>
            <DialogTitle>Ønsker du å logge ut?</DialogTitle>
            <DialogActions>
              <Button onClick={() => this.setState({ logoutopen: false })} color="primary">
                Avbryt
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  window.location = `/idp-auth/self-log-me-out?post_logout_redirect_uri=${window.location.origin.replace('admin', '')}/`;
                }}
                color="primary"
              >
                Logg ut
              </Button>
            </DialogActions>
          </Dialog>
        </Drawer>
        <div className={classes.content}>
          <Switch>
            {meFetched && [
              meError && <Route key="registrer" path="/registrer" component={Register} />,
            ]}
            <Route path="/" component={(meFetched && !meError) ? landingPages[me.active] : NotRegistered} />

          </Switch>
        </div>
      </div>
    );
  }
}

Politician.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  me: PropTypes.object.isRequired,
  users: PropTypes.object.isRequired,
};

const fullWidth = '14rem';
const mobileWidth = '3.4rem';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  flex: {
    display: 'flex',
    flexWrap: 'wrap-reverse',
    justifyContent: 'space-between',
  },
  drawer: {
    [theme.breakpoints.up('xs')]: {
      width: fullWidth,
    },
    [theme.breakpoints.down('sm')]: {
      width: mobileWidth,
    },
    flexShrink: 0,
  },
  drawerPaper: {
    [theme.breakpoints.up('xs')]: {
      width: fullWidth,
    },
    [theme.breakpoints.down('sm')]: {
      width: mobileWidth,
    },
  },
  navItemIcon: {
    marginRight: 0,
  },
  toolbar: {
    width: '100%',
    paddingLeft: '0',
    paddingRight: '0',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  logo: {
    width: '3rem',
    height: '3rem',
    marginLeft: '4px',
  },
  grow: {
    flexGrow: 1,
  },
  bottom: {
    width: '100%',
    bottom: 0,
    position: 'absolute',
  },
  buttonbox: {
    margin: '1rem',
    marginTop: '0.5rem',
  },
  loginIcon: {
    bottom: 0,
    position: 'absolute',
    margin: '0.5rem',
  },
  selectedItem: {
    color: theme.palette.primary.main,
  },
});

const mapStateToProps = ({ profile, me, users }) => ({
  profile,
  me,
  users,
});


export default connect(mapStateToProps)(withStyles(styles)(withRouter(Politician)));
